export const applyTheme = (theme) => {
  if (!theme) return;

  const root = document.documentElement;

  if (theme.background_color) {
    root.style.setProperty('--background-color', theme.background_color);
  }

  if (theme.button_color) {
    root.style.setProperty('--button-color', theme.button_color);
  }

  if (theme.hover_color) {
    root.style.setProperty('--hover-color', theme.hover_color);
  }
};

export const clearTheme = () => {
  const root = document.documentElement;
  root.style.removeProperty('--background-color');
  root.style.removeProperty('--button-color');
  root.style.removeProperty('--hover-color');
};